
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

import 'es6-promise/auto';
import VueRouter from 'vue-router';
import { routes } from './frontend-routes';
import globalMixins from './mixins';
import vSelect from 'vue-select';
import VueAutosuggest from "vue-autosuggest";
import VueToasted from 'vue-toasted';
import VueMask from 'v-mask';

Vue.use(VueMask);

Vue.use(VueRouter);

Vue.use(VueAutosuggest);

Vue.use(VueToasted, { position: "bottom-center", iconPack: 'fontawesome', duration: 2000 });

Vue.mixin(globalMixins);


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
Vue.component('v-select', vSelect);

const router = new VueRouter({
    mode: 'history',
    routes
});


// WEBPACK FOOTER //
// ./resources/assets/js/frontend2.js